import { useEffect, useState } from "react";
import TabsSelector from "../../../Farm/TabsSelector";
import RemoveBoth from "./Both";
import RemoveItem from "./Item";
import { TextNoDataLiquidity } from "../styled";

const RemoveLiquidity = ({
  datasChart,
  dataLiquidity,
  poolDetail,
  slippageTolerance,
  handleGetDataChart,
  binActive
}: any) => {
  const [tab, setTab] = useState(1);
  const [priceX, setPriceX] = useState(0);
  const [priceY, setPriceY] = useState(0);
  const [bin, setBin] = useState<any>([]);
  const [numBins, setNumBins] = useState(0);
  const [range, setRange] = useState([0, 0]);
  const [minBinId, setMinBinId] = useState<number | null>(null);
  const [maxBinId, setMaxBinId] = useState<number | null>(null);
  const [loading, setLoading] = useState(false);

  const TABS = [
    {
      title: "Remove Both",
      value: 1,
    },
    {
      title: `Remove ${
        datasChart?.series[0]?.name ? datasChart?.series[0]?.name : "--"
      }`,
      value: 2,
    },
    {
      title: `Remove ${
        datasChart?.series[1]?.name ? datasChart?.series[1]?.name : "--"
      }`,
      value: 3,
    },
  ];

  const handleSwitchTabs = () => {
    switch (tab) {
      case 1:
        return (
          <RemoveBoth
            dataLiquidity={dataLiquidity}
            poolDetail={poolDetail}
            bin={bin}
            priceX={priceX}
            priceY={priceY}
            numBins={numBins}
            range={range}
            onChangeSlider={onChangeSlider}
            slippageTolerance={slippageTolerance}
            setLoading={setLoading}
            loading={loading}
            minBinId={minBinId}
            maxBinId={maxBinId}
            handleGetDataChart={handleGetDataChart}
          />
        );
      case 2:
        return (
          <RemoveItem
            item={1}
            poolDetail={poolDetail}
            addressX={poolDetail?.tokenX.address}
            addressY={poolDetail?.tokenY.address}
            price={priceX}
            slippageTolerance={slippageTolerance}
            bin={bin}
            setLoading={setLoading}
            loading={loading}
            handleGetDataChart={handleGetDataChart}
            isHide={binActive?.id <= dataLiquidity?.maxBin}
            binActive={binActive}
            dataLiquidity={dataLiquidity}
          />
        );
      case 3:
        return (
          <RemoveItem
            item={2}
            poolDetail={poolDetail}
            addressX={poolDetail?.tokenX.address}
            addressY={poolDetail?.tokenY.address}
            price={priceY}
            slippageTolerance={slippageTolerance}
            bin={bin}
            setLoading={setLoading}
            loading={loading}
            handleGetDataChart={handleGetDataChart}
            isHide={binActive?.id >= dataLiquidity?.minBin}
            binActive={binActive}
            dataLiquidity={dataLiquidity}
          />
        );
      default:
        break;
    }
  };

  const calculateTokenAmounts = (minPrice: number, maxPrice: number) => {
    const minBin = findClosestBin(minPrice);
    const maxBin = findClosestBin(maxPrice);
    const minIndex = bin.findIndex((binItem: any) => binItem.id === minBin.id);
    const maxIndex = bin.findIndex((binItem: any) => binItem.id === maxBin.id);

    let totalX = 0;
    let totalY = 0;

    for (let i = minIndex; i <= maxIndex; i++) {
      totalX += bin[i].x;
      totalY += bin[i].y;
    }

    setPriceX(totalX);
    setPriceY(totalY);
  };

  useEffect(() => {
    if (dataLiquidity?.data_Chart) {
      setBin(dataLiquidity?.binRanges);
    }
  }, [dataLiquidity?.data_Chart]);

  const handleGetDefaultBin = async () => {
    const newMinPrice = bin[0]?.price;
    const newMaxPrice = bin[bin?.length - 1].price;
    const newMinBinId = bin[0].id;
    const newMaxBinId = bin[bin.length - 1].id;
    setRange([newMinPrice, newMaxPrice]);
    setNumBins(bin?.length);
    setMinBinId(newMinBinId);
    setMaxBinId(newMaxBinId);

    calculateTokenAmounts(newMinPrice, newMaxPrice);
  };

  useEffect(() => {
    if (bin?.length > 0) {
      handleGetDefaultBin();
    }
  }, [bin]);

  const findClosestBin = (price: any) => {
    return bin?.reduce((prev: any, curr: any) =>
      Math.abs(curr.price - price) < Math.abs(prev.price - price) ? curr : prev
    );
  };

  const calculateNumBins = (min: any, max: any) => {
    if (bin?.length === 0) return 0;
    const minBin = findClosestBin(min);
    const maxBin = findClosestBin(max);
    const minIndex = bin.findIndex((binItem: any) => binItem.id === minBin.id);
    const maxIndex = bin.findIndex((binItem: any) => binItem.id === maxBin.id);
    return maxIndex - minIndex + 1;
  };

  const onChangeSlider = (value: any) => {
    if (bin?.length > 0) {
      const [minPrice, maxPrice] = value;
      setRange(value);
      const binsInRange = calculateNumBins(value[0], value[1]);
      setNumBins(binsInRange);

      const minBin = findClosestBin(minPrice);
      const maxBin = findClosestBin(maxPrice);

      // Set minBinId and maxBinId
      setMinBinId(minBin.id);
      setMaxBinId(maxBin.id);

      calculateTokenAmounts(value[0], value[1]);
    }
  };

  return (
    <div>
      {!dataLiquidity ? (
        <TextNoDataLiquidity>
          You have no liquidity in this pool
        </TextNoDataLiquidity>
      ) : (
        <>
          <TabsSelector
            data={[...TABS]}
            callBack={(data: any) => {
              setTab(data.value);
            }}
            active={tab}
          />
          {handleSwitchTabs()}
        </>
      )}
    </div>
  );
};

export default RemoveLiquidity;
